import axios from "axios";

export async function getIssuesApi(titleID, isPdf) {
  const uri =
    process.env.REACT_APP_API_ROOT +
    "titles/" +
    titleID +
    (isPdf ? "/pdf_books" : "/web_content_books");

  let response = await fetch(uri);

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function getCurIssueOfTitle(titleID) {
  const uri =
    process.env.REACT_APP_API_ROOT +
    "titles/" +
    titleID +
    "/production_current_issue";

  let response = await fetch(uri);

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function delIssueApi(id, isPdf) {
  const bookType = isPdf ? "pdf_books/" : "web_content_books/";

  let response = await fetch(process.env.REACT_APP_API_ROOT + bookType + id, {
    method: "DELETE"
  });

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function createWebIssueApi(titleID, issueID) {
  let response = await fetch(
    process.env.REACT_APP_API_ROOT + "titles/" + titleID + "/web_content_books",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      },
      body: new URLSearchParams({
        issue: issueID
      })
    }
  );

  let data = await response.json();

  if (!response.ok) {
    throw Error(response.statusText);
  }

  return data;
}

export function createPdfIssueApi(
  titleID,
  issueID,
  pdfFile,
  pubuID,
  pubuCategory,
  xmlParsedResult,
  progressCallback,
  productID,
  contentsID
) {
  let bodyFormData = new FormData();
  bodyFormData.set("issue", issueID);
  bodyFormData.set("pubu_product_id", pubuID);
  bodyFormData.set("pubu_product_category", pubuCategory);
  bodyFormData.set("product_id", productID);
  bodyFormData.set("content_id", contentsID);

  if (xmlParsedResult != null) {
    const available_from = new Date(xmlParsedResult.availableFrom);
    if (!isNaN(available_from)) {
      bodyFormData.set(
        "available_from",
        Math.floor(available_from.getTime() / 1000)
      );
    }

    const available_to = new Date(xmlParsedResult.availableTo);
    if (!isNaN(available_to)) {
      bodyFormData.set(
        "available_to",
        Math.floor(available_to.getTime() / 1000)
      );
    }
  }

  bodyFormData.append("pdf", pdfFile);

  let promise = new Promise(function(resolve, reject) {
    axios
      .request({
        method: "POST",
        url:
          process.env.REACT_APP_API_ROOT + "titles/" + titleID + "/pdf_books",
        data: bodyFormData,
        onUploadProgress: p => {
          progressCallback((p.loaded * 100) / p.total);
        }
      })
      .then(
        data => {
          resolve(data);
        },
        e => {
          reject(e);
        }
      );
  });

  return promise;
}

export async function getIssueProdApi(issueID) {
  const uri =
    process.env.REACT_APP_API_ROOT +
    "pdf_books/" +
    issueID +
    "/production_data";

  let response = await fetch(uri);

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function getAnIssueApi(issueID, isPdf) {
  const bookType = isPdf ? "pdf_books" : "web_content_books";

  let response = await fetch(
    process.env.REACT_APP_API_ROOT + bookType + "/" + issueID
  );

  if (!response.ok) {
    if (response.status === 404) {
      throw Error(404);
    } else {
      throw Error(response.statusText);
    }
  }

  let data = await response.json();

  return data;
}

export async function getTextExtractionProgressApi(issueID) {
  const uri =
    process.env.REACT_APP_API_ROOT + "pdf_books/" + issueID + "/text_progress";

  let response = await fetch(uri);

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function getHTMLifyProgressApi(issueID) {
  const uri =
    process.env.REACT_APP_API_ROOT +
    "pdf_books/" +
    issueID +
    "/htmlify_progress";

  let response = await fetch(uri);

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function publishApi(issueID) {
  const uri =
    process.env.REACT_APP_API_ROOT + "pdf_books/" + issueID + "/publish";

  let response = await fetch(uri, {
    method: "POST"
  });

  if (!response.ok) {
    try {
      let data = await response.json();
      throw Error(data.message);
    } catch (e) {
      throw e;
    }
  }

  let data = await response.json();

  return data;
}

export async function publishFtpApi(issueID) {
  const uri =
    process.env.REACT_APP_API_ROOT + "pdf_books/" + issueID + "/fujisan_stuff";

  let response = await fetch(uri, {
    method: "POST"
  });

  if (!response.ok) {
    try {
      let data = await response.json();
      throw Error(data.message);
    } catch (e) {
      throw e;
    }
  }

  let data = await response.json();

  return data;
}

export async function publishPubuApi(issueID) {
  const uri = process.env.REACT_APP_API_ROOT + "pdf_books/" + issueID + "/pubu";

  let response = await fetch(uri, {
    method: "POST"
  });

  if (!response.ok) {
    try {
      let data = await response.json();
      throw Error(data.message);
    } catch (e) {
      throw e;
    }
  }

  let data = await response.json();

  return data;
}

export async function updateIssueMetaApi(issueID, isPdf, metaData) {
  const bookType = isPdf ? "pdf_books/" : "web_content_books/";

  let bodyFormData = new FormData();
  bodyFormData.set("issue", metaData.issueName);
  bodyFormData.set("description", metaData.description);
  bodyFormData.set("is_adult", metaData.isAdult);
  bodyFormData.set("year", metaData.year);
  bodyFormData.set("pubu_product_id", metaData.pubuProductID);
  bodyFormData.set("pubu_product_category", metaData.pubuProductCategory);
  bodyFormData.set("content_id", metaData.contentsID);
  bodyFormData.set("product_id", metaData.productID);

  const off_shelf_at = new Date(metaData.offShelfAt);
  if (!isNaN(off_shelf_at)) {
    bodyFormData.set("off_shelf_at", Math.floor(off_shelf_at.getTime() / 1000));
  }

  const published_at = new Date(metaData.publishAt);
  if (!isNaN(published_at)) {
    bodyFormData.set("published_at", Math.floor(published_at.getTime() / 1000));
  }

  const available_from = new Date(metaData.availableFrom);
  if (!isNaN(available_from)) {
    bodyFormData.set(
      "available_from",
      Math.floor(available_from.getTime() / 1000)
    );
  }

  const available_to = new Date(metaData.availableTo);
  if (!isNaN(available_to)) {
    bodyFormData.set("available_to", Math.floor(available_to.getTime() / 1000));
  }

  if (metaData.isLeftFlip != null) {
    bodyFormData.append("is_left_flip", metaData.isLeftFlip);
  }

  if (metaData.cover != null) {
    bodyFormData.append("cover", metaData.cover);
  }

  let promise = new Promise(function(resolve, reject) {
    axios
      .request({
        method: "POST",
        url: process.env.REACT_APP_API_ROOT + bookType + issueID,
        data: bodyFormData
      })
      .then(
        data => {
          resolve(data);
        },
        e => {
          reject(e);
        }
      );
  });

  return promise;
}

export async function getMediasApi(issueID, isPdf, isVideo) {
  const mediaType = isVideo ? "videos" : "audios";

  const uri =
    process.env.REACT_APP_API_ROOT + mediaType + "?book_id=" + issueID;

  let response = await fetch(uri);

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function addYoutube(issueID, isPdf, uri) {
  const bookType = isPdf ? "pdf_books/" : "web_content_books/";

  let response = await fetch(
    process.env.REACT_APP_API_ROOT +
      bookType +
      issueID +
      "/download_video_from_youtube",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      },
      body: new URLSearchParams({
        url: uri
      })
    }
  );

  let data = await response.json();

  if (!response.ok) {
    throw Error(response.statusText);
  }

  return data;
}

export async function getUploadCredentialApi(filename) {
  const uri =
    process.env.REACT_APP_API_ROOT +
    "s3/pre_authorized_form?filename=" +
    filename;

  let response = await fetch(uri);

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export function uploadMediaFileApi(file, credential, progressCallback) {
  let bodyFormData = new FormData();
  bodyFormData.set("AWSAccessKeyId", credential.AWSAccessKeyId);
  bodyFormData.set("key", credential.key);
  bodyFormData.set("acl", credential.acl);
  bodyFormData.set("policy", credential.policy);
  bodyFormData.set("signature", credential.signature);
  bodyFormData.set("x-amz-security-token", credential["x-amz-security-token"]);
  bodyFormData.append("file", file);

  let promise = new Promise(function(resolve, reject) {
    axios
      .request({
        method: "POST",
        url: process.env.REACT_APP_S3,
        data: bodyFormData,
        headers: {
          "Access-Control-Allow-Origin": "*"
        },
        onUploadProgress: p => {
          progressCallback((p.loaded * 100) / p.total);
        }
      })
      .then(
        data => {
          resolve(data);
        },
        e => {
          reject(e);
        }
      );
  });

  return promise;
}

export async function addMediaToServerApi(
  issueID,
  isPdf,
  title,
  s3Key,
  mediaType
) {
  const bookType = isPdf ? "pdf_books/" : "web_content_books/";

  let response = await fetch(
    process.env.REACT_APP_API_ROOT + bookType + issueID + "/" + mediaType + "s",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      },
      body: new URLSearchParams({
        title,
        s3_key: s3Key
      })
    }
  );

  let data = await response.json();

  if (!response.ok) {
    throw Error(response.statusText);
  }

  return data;
}

export async function deleteMediaApi(id, isVideo) {
  const mediaType = isVideo ? "videos/" : "audios/";

  let response = await fetch(process.env.REACT_APP_API_ROOT + mediaType + id, {
    method: "DELETE"
  });

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function saveMediaMetaApi(id, isVideo, serverData) {
  const mediaType = isVideo ? "videos/" : "audios/";

  let response = await fetch(process.env.REACT_APP_API_ROOT + mediaType + id, {
    headers: { "Content-Type": "application/json" },
    method: "PUT",
    body: JSON.stringify(serverData)
  });

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function getCopyConfigApi(isPdf, issueID) {
  const bookType = isPdf ? "pdf_books/" : "web_content_books/";
  const uri =
    process.env.REACT_APP_API_ROOT + bookType + issueID + "/copy_config";

  let response = await fetch(uri);

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function copyApi(
  isPdf,
  issueID,
  titleID,
  destinationName,
  tocOnly
) {
  const bookType = isPdf ? "pdf_books/" : "web_content_books/";
  const uri = process.env.REACT_APP_API_ROOT + bookType + issueID + "/copy";

  const inputData = {
    title_id: titleID,
    destination_name: destinationName,
    only_toc: tocOnly
  };

  let response = await fetch(uri, {
    headers: { "Content-Type": "application/json" },
    method: "POST",
    body: JSON.stringify(inputData)
  });

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function completeApi(isPdf, issueID) {
  const bookType = isPdf ? "pdf_books/" : "web_content_books/";

  let response = await fetch(
    process.env.REACT_APP_API_ROOT + bookType + issueID + "/complete",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      }
    }
  );

  if (!response.ok) {
    try {
      let data = await response.json();
      throw Error(data.message);
    } catch (e) {
      throw e.toString();
    }
  }

  let data = await response.json();

  return data;
}

export async function completeCheckApi(isPdf, issueID) {
  const bookType = isPdf ? "pdf_books/" : "web_content_books/";

  let response = await fetch(
    process.env.REACT_APP_API_ROOT + bookType + issueID + "/complete_check",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      }
    }
  );

  if (!response.ok) {
    try {
      let data = await response.json();
      throw Error(data.message);
    } catch (e) {
      throw e.toString();
    }
  }

  let data = await response.json();

  return data;
}

export async function downloadEpubApi(issueID, epubLink) {
  await fetch(epubLink, {
    method: "GET"
  })
    .then(response => response.blob())
    .then(blob => {
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = url;
      a.download = issueID + ".epub";
      document.body.appendChild(a);
      a.click();
      a.remove();
    });
}
